import React from 'react';

export const Col = ({ children, span, spanMobile, ...props }) => (
  <div
    className={spanMobile ? [
      `pure-u-md-${span}-24`,
      `pure-u-${spanMobile || span}-24`,
    ].join(' ') : `pure-u-${span}-24`}
    {...props}
  >
    {children}
  </div>
);